"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarRatingInput = void 0;
const react_1 = __importStar(require("react"));
const SendButton_1 = require("./buttons/SendButton");
const StarRatingInput = ({ buttonLabel, onSubmit, options, }) => {
    var _a;
    const [selectedRating, setSelectedRating] = (0, react_1.useState)(0);
    return (react_1.default.createElement("div", { className: "flex flex-row" },
        react_1.default.createElement("div", { className: "flex flex-col mt-2" },
            react_1.default.createElement("div", { className: "flex flex-row" }, Array.from(new Array(((_a = options === null || options === void 0 ? void 0 : options.range) !== null && _a !== void 0 ? _a : "10") === "10" ? 10 : 5)).map((_, index) => {
                return selectedRating < index + 1 ? (react_1.default.createElement(StarButton, { onClick: () => setSelectedRating(index + 1) })) : (react_1.default.createElement(StarButton, { onClick: () => setSelectedRating(index + 1), active: true }));
            })),
            react_1.default.createElement("div", { className: "flex flex-row mt-4" },
                react_1.default.createElement("div", { className: "flex flex-1" }, selectedRating > 0 && (react_1.default.createElement(SendButton_1.SendButton, { onClick: () => onSubmit(selectedRating.toString()), label: buttonLabel })))))));
};
exports.StarRatingInput = StarRatingInput;
const StarButton = ({ onClick, active, }) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", onClick: onClick, className: "mr-2 lg:w-6 w-5 star-icon " + (active ? "active" : "") },
    react_1.default.createElement("path", { d: "M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z" })));
//# sourceMappingURL=StarRatingInput.js.map